import type { Account } from '../../generated-types';

export enum AccountViewTypes {
    NORMAL = 'NORMAL_ACCOUNT',
    CREDIT = 'CREDIT_ACCOUNT',
    BSU = 'BSU_ACCOUNT',
}

export enum BsuDisplay {
    YEARLY = 'YEARLY',
    TOTAL = 'TOTAL',
}

export interface Props {
    account?: Account;
    className?: string;
    /**
     * @default false
     */
    isLoading?: boolean;
}

export type BsuDetails = {
    balance: number;
    maxAmountToSave: number;
    amountToSave: number;
    underOneYearBeforeFullBsu?: boolean;
    maxedOutBsu: boolean;
};
